<template>
  <!-- 这个组件已经被复制到/src/views/components/v-upload,但是不知道其他开发人员是否引用了这个组件,所以不删除,如果要使用上传组件,请使用 /src/views/components/v-upload-->
  <!-- 这个组件已经被复制到/src/views/components/v-upload,但是不知道其他开发人员是否引用了这个组件,所以不删除,如果要使用上传组件,请使用 /src/views/components/v-upload-->
  <!-- 这个组件已经被复制到/src/views/components/v-upload,但是不知道其他开发人员是否引用了这个组件,所以不删除,如果要使用上传组件,请使用 /src/views/components/v-upload-->
  <!-- 这个组件已经被复制到/src/views/components/v-upload,但是不知道其他开发人员是否引用了这个组件,所以不删除,如果要使用上传组件,请使用 /src/views/components/v-upload-->
  <div>
    <el-upload
      :file-list="fileList"
      list-type="picture-card"
      :http-request="httpRequest"
      multiple
      :disabled="disabled || limitDisabled"
      :limit="3"
    >
      <div slot="trigger">
        <span v-if="fileList.length == limit">已到达数量上限</span>
        <i v-else class="el-icon-plus"></i>
      </div>
      <div slot="file" slot-scope="{ file }">
        <img
          v-if="
            file.originalName &&
            ['jpg', 'jpeg', 'png', 'gif'].includes(
              file.originalName.split('.').pop()
            )
          "
          class="el-upload-list__item-thumbnail"
          :src="file.link"
          alt=""
        />
        <video
          v-else-if="
            file.originalName &&
            ['mp4', 'mpeg4', 'ogg', 'webm'].includes(
              file.originalName.split('.').pop()
            )
          "
          class="el-upload-list__item-thumbnail"
          :src="file.link"
        />
        <div v-else style="padding: 5px; line-height: 20px">
          {{ file.originalName }}<br />
          不支持预览
        </div>
        <span class="el-upload-list__item-actions">
          <span
            class="el-upload-list__item-preview"
            @click="handlePictureCardPreview(file)"
          >
            <i class="el-icon-zoom-in"></i>
          </span>
          <span
            class="el-upload-list__item-delete"
            @click="handleDownload(file)"
          >
            <i class="el-icon-download"></i>
          </span>
          <span
            v-if="!disabled"
            class="el-upload-list__item-delete"
            @click="handleRemove(file)"
          >
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
      <div slot="tip" class="el-upload__tip" v-if="!disabled">
        提示：上传文件不大于{{ max / (1024 * 1024) }}MB，上传数量
        {{ fileList.length }}/{{ limit }}
      </div>
    </el-upload>
    <el-dialog :visible.sync="maskShow" append-to-body
               :close-on-click-modal="false">
      <div v-if="maskItem.originalName">
        <img
          style="max-height: 600px"
          v-if="
            maskItem.originalName &&
            ['jpg', 'jpeg', 'png', 'gif'].includes(
              maskItem.originalName.split('.').pop()
            )
          "
          :src="maskItem.link"
        />
        <video
          style="max-height: 600px"
          v-else-if="
            maskItem.originalName &&
            ['mp4', 'mpeg4', 'ogg', 'webm'].includes(
              maskItem.originalName.split('.').pop()
            )
          "
          :src="maskItem.link"
          controls
        ></video>
        <div v-else style="padding: 20px">
          {{ maskItem.originalName }} <br />
          不支持预览
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { putFile } from "@/api/crmedical/contract/add";
import website from "@/config/website";
export default {
  props: {
    fileList: {
      type: Array,
      default: [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    max: {
      type: Number,
      default: 10 * 1024 * 1024,
    },
    limit: {
      type: Number,
      default: 3,
    },
  },
  watch: {
    fileList() {
      let len = this.fileList.length;
      this.limitDisabled = len >= this.limit;
    },
  },
  data() {
    return {
      maskShow: false,
      maskItem: {},
      limitDisabled: false,
    };
  },
  methods: {
    handlePictureCardPreview(file) {
      console.log("213==>", 213);
      console.log("file==>", file);
      this.maskItem = file;
      this.maskShow = true;
    },
    //同步数据到父组件
    update() {
      // status:'success' 后端会报错
      this.fileList.forEach((item) => {
        item.status = 1;
      });
      let len = this.fileList.length;
      this.limitDisabled = len >= this.limit;
      this.$emit("update:fileList", this.fileList);
    },
    //上传方法
    httpRequest(file) {
      if (this.limitDisabled) return;
      this.max = this.max || website.maxUploadSize;
      if (file.file.size > this.max) {
        this.$message.error(`文件不能大于${this.max / (1024 * 1024)}MB`);
      } else {
        let fd = new FormData();
        fd.append("file", file.file);
        putFile(fd)
          .then((res) => {
            res.data.uid = file.file.uid;
            if (res.success) {
              res.data["id"] = res.data["attachId"];
              this.fileList.push(res.data);
              this.update();
            }
          })
          .catch((err) => {
            console.log("err==>", err);
          });
      }
    },
    //移除
    handleRemove(file) {
      let deleteIndex;
      this.fileList.forEach((item, index) => {
        if (item == file) {
          deleteIndex = index;
        }
      });
      if (deleteIndex !== undefined) {
        this.fileList.splice(deleteIndex, 1);
      }
      this.update();
    },
    //下载方法
    handleDownload(file) {
      const url = file.link;
      const ele = document.createElement("a");
      ele.setAttribute("href", url);
      ele.setAttribute("download", "download");
      ele.click();
    },
  },
};
</script>
